import { Box, Typography } from "@mui/material";
import { QuoteButton } from "../../../components/QuoteButton";
import { displayFont } from "../../../styles/theme";

const lines = ["Crescer com propósito.", "Tocar com identidade.", "Criar experiências através da música."];

export function Manifesto() {
  return (
    <Box
      component="section"
      sx={{
        textAlign: "center",
        px: { xs: 3, md: 8 },
        py: { xs: 8, md: 12 },
        borderRadius: 6,
        border: "1px solid",
        borderColor: "divider",
        background: (theme) =>
          `radial-gradient(ellipse at top, ${theme.palette.primary.main}33 0%, transparent 70%), #121212`,
      }}
    >
      <Typography sx={{ fontFamily: displayFont, fontSize: { xs: "2.5rem", md: "3.5rem" }, color: "primary.main", lineHeight: 1 }}>
        Groowv.
      </Typography>

      <Box component="blockquote" sx={{ m: 0, mt: 4 }}>
        {lines.map((line) => (
          <Typography
            key={line}
            sx={{ fontFamily: displayFont, fontSize: { xs: "1.5rem", md: "2.25rem" }, lineHeight: 1.35 }}
          >
            {line}
          </Typography>
        ))}
      </Box>

      <QuoteButton size="large" sx={{ mt: 6, px: 5, py: 1.5 }} />
    </Box>
  );
}
